import React from 'react';
import { Card, Flex, Text, styled } from '@goodrx/matisse';

const StyledCard = styled(Card)`
  border: none;
  cursor: pointer;
  position: relative;
  outline: none;

  &:focus,
  &:hover {
    #see-prices {
      text-decoration: underline;
    }
  }
`;

const StyledImage = styled.img`
  max-width: 60px;
  max-height: 60px;
  background-color: white;
  padding: 4px;
  border-radius: 50%;
`;

export const DiscoverPrices: React.FC<{ onBannerClick: () => void }> = ({ onBannerClick }) => (
  <StyledCard onClick={onBannerClick} onKeyPress={onBannerClick} tabIndex={0} role="button">
    <Card.Body as={Flex} bg="#eefaf6" alignItems="center" flexDirection={{ _: 'column', sm: 'row' }}>
      <StyledImage src="/images/illustrations/bottle-pills-bag.png" />

      <Flex flexDirection="column" ml={3} textAlign={{ _: 'center', sm: 'left' }} fontWeight="600">
        <Text color="black" mb={2} mt={{ _: 2, sm: 0 }}>
          Save up to 80% on your prescriptions!
        </Text>

        <Text id="see-prices" color="secondary" fontSize={14}>
          See discounted prices at pharmacies near you.
        </Text>
      </Flex>
    </Card.Body>
  </StyledCard>
);
